// extracted by mini-css-extract-plugin
export default {"search-input-container":"SearchInput_search-input-container__qnnNS","search-input":"SearchInput_search-input__2ftTT","search-icon":"SearchInput_search-icon__PBMqd"};